<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import ../../assets/sass/m3_forms
@import sass/devisForm
@import sass/popinDevis
</style>

<template>
    <Zone
        :id="data.id"
        :dataLabel="data.dataLabel"
        :contrast="contrast"
        class="g_devisForm"
        autoHeight>
        <Heading
            v-if="pageIs('devis-int')"
            :level="1"
            v-html="data.titles.int" />
        <Heading
            v-if="pageIs('devis-ext')"
            :level="1"
            v-html="data.titles.ext" />
        <Heading
            v-if="pageIs('devis-rooms')"
            :level="1"
            v-html="data.titles.rooms" />
        <Paragraph :content="data.content" size="XL" />
        <form id="form" @submit="checkForm">
            <div class="g_form">
                <div class="g_table">
                    <div class="g_cell">

                        <fieldset>
                            <legend>
                                <Paragraph :content="data.fieldset.coordinates" size="L" />
                            </legend>
                            <Textfield v-model="data.form.lastname.value" :data="data.form.lastname" :captcha="true" />
                            <Select v-model="data.form.type.value" :data="data.form.type" />
                            <div class="g_hidden">
                                <Textfield v-model="data.form.type.other.othertype.value" :data="data.form.type.other.othertype" :nomargin="true" />
                            </div>
                            <Textfield v-model="data.form.company.value" :data="data.form.company" />
                            <Select v-model="data.form.date.value" :data="data.form.date" />
                            <div class="g_hidden">
                                <Textfield v-model="data.form.date.other.otherdate.value" :data="data.form.date.other.otherdate" :nomargin="true" />
                            </div>
                            <Textfield v-model="data.form.street.value" :data="data.form.street" />
                            <Textfield v-model="data.form.city.value" :data="data.form.city" />
                            <Textfield v-model="data.form.zipcode.value" :data="data.form.zipcode" :small="true" />
                            <Textfield v-model="data.form.name.value" :data="data.form.name" />
                            <Textfield v-model="data.form.email.value" :data="data.form.email" />
                            <Textfield v-model="data.form.tel.value" :data="data.form.tel" />
                            <!-- <Textarea v-model="data.form.comment" :data="data.form.comment" /> -->
                            <template v-if="pageIs('devis-int')">
                                <div
                                    class="g_sampleImg"
                                    v-img-src="{ folder: 'form', name: 'sample-int2', ext: 'png', suffix: false }" />
                                <Radiobuttons v-model="data.int.sample.value" :data="data.int.sample" />
                            </template>
                            <template v-if="pageIs('devis-rooms')">
                                <div
                                    class="g_sampleImg"
                                    v-img-src="{ folder: 'form', name: 'sample-rooms2', ext: 'png', suffix: false }" />
                                <Radiobuttons v-model="data.rooms.sample.value" :data="data.rooms.sample" />
                            </template>
                        </fieldset>
                    </div>

                    <div class="g_cell" v-if="pageIs('devis-int')">
                        <fieldset>
                            <legend>
                                <Paragraph :content="data.fieldset.infos" size="L" />
                            </legend>
                            <Textfield v-model="data.int.levels.value" :data="data.int.levels" />
                            <Textfield v-model="data.int.stairs.value" :data="data.int.stairs" />
                            <Textfield v-model="data.int.elevators.value" :data="data.int.elevators"/>
                            <Textfield v-model="data.int.simplerooms.value" :data="data.int.simplerooms"/>
                            <Textfield v-model="data.int.doublerooms.value" :data="data.int.doublerooms" />
                            <Textfield v-model="data.int.mainrooms.value" :data="data.int.mainrooms" />
                            <Textfield v-model="data.int.offices.value" :data="data.int.offices" />
                            <Textfield v-model="data.int.toilets.value" :data="data.int.toilets" />
                            <Textfield v-model="data.int.technicalrooms.value" :data="data.int.technicalrooms" />
                            <Textfield v-model="data.int.complementaryrooms.value" :data="data.int.complementaryrooms" />
                            <Radiobuttons v-model="data.int.homebank.value" :data="data.int.homebank" />
                            <Radiobuttons v-model="data.int.generalpanel.value" :data="data.int.generalpanel" />
                        </fieldset>
                    </div>

                    <div class="g_cell" v-if="pageIs('devis-ext')">
                        <fieldset>
                            <legend>
                                <Paragraph :content="data.fieldset.infos" size="L" />
                            </legend>
                            <Textfield v-model="data.ext.nbtotems.value" :data="data.ext.nbtotems" />
                            <Select v-model="data.ext.typetotems.value" :data="data.ext.typetotems" />
                            <div class="g_hidden">
                                <Textfield v-model="data.ext.typetotems.other.height.value" :data="data.ext.typetotems.other.height" :nomargin="true"/>
                                <Textfield v-model="data.ext.typetotems.other.width.value" :data="data.ext.typetotems.other.width" :nomargin="true"/>
                            </div>
                            <Radiobuttons v-model="data.ext.complement.value" :data="data.ext.complement" :more="true" />
                            <div class="g_hidden">
                                <Textfield v-model="data.ext.complement.other.nbpanels.value" :data="data.ext.complement.other.nbpanels" />
                                <Textfield v-model="data.ext.complement.other.panelheight.value" :data="data.ext.complement.other.panelheight" :nomargin="true" />
                                <Textfield v-model="data.ext.complement.other.panelwidth.value" :data="data.ext.complement.other.panelwidth" />
                            </div>
                        </fieldset>
                    </div>

                    <div class="g_cell" v-if="pageIs('devis-rooms')">
                        <fieldset>
                            <legend>
                                <Paragraph :content="data.fieldset.project" size="L" />
                            </legend>
                            <Textfield v-model="data.rooms.bedrooms.value" :data="data.rooms.bedrooms" />
                            <Textfield v-model="data.rooms.doors.value" :data="data.rooms.doors" />
                            <Radiobuttons v-model="data.rooms.option.value" :data="data.rooms.option" :more="true" />
                            <div class="g_hidden">
                                <Textfield v-model="data.rooms.option.other.nb0.value" :data="data.rooms.option.other.nb0" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb1.value" :data="data.rooms.option.other.nb1" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb2.value" :data="data.rooms.option.other.nb2" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb3.value" :data="data.rooms.option.other.nb3" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb4.value" :data="data.rooms.option.other.nb4" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb5.value" :data="data.rooms.option.other.nb5" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb6.value" :data="data.rooms.option.other.nb6" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb7.value" :data="data.rooms.option.other.nb7" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb8.value" :data="data.rooms.option.other.nb8" :col="true" />
                                <Textfield v-model="data.rooms.option.other.nb9.value" :data="data.rooms.option.other.nb9" :col="true" />
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
            <div class="g_submit">
                <div>
                    <input
                        type="submit"
                        name="submit"
                        :value="config.form.submit.label"
                        class="g_btn g_btnBuy" />
                </div>
            </div>
        </form>
        <div class="g_infos">
            <template v-if="!isNotSended">
                <Paragraph v-if="!isChecking && !isNotValid && !isSending && !isSended " :content="config.form.mandatoryAll" size="M" />
                <Paragraph v-else-if="isChecking" :content="config.form.checking" size="M" />
                <Paragraph v-else-if="isNotValid" :content="config.form.warning" size="M" class="g_warning" />
                <Paragraph v-else-if="isSending" :content="config.form.sending" size="M" />
                <Paragraph v-else-if="isSended" :content="data.success" size="M" />
            </template>
            <template v-else>
                <Paragraph :content="config.form.error" size="M" class="g_warning" />
            </template>
        </div>
        <div class="g_personnal" :class="{'g_opened' : isOpen}">
            <Cta
                type="button"
                class="g_link"
                @click="openClose"
                :content="config.form.disclaimer" />
            <Paragraph :content="config.form.personnal" size="S" />
        </div>
        <Popin
            ref="popin"
            class="g_popinDevis g_popinValidate"
            v-model="popinOpened"
            :closeLabel="config.popin.close"
            @focusBack="$emit('focusBack')">
            <slot name="main">
                <div class="g_popinContainer">
                    <div class="g_text">
                        <Paragraph :content="data.success" size="XL" />
                        <Paragraph :content="data.more" size="L" />
                        <Cta
                            v-if="link1"
                            type="text"
                            class="g_btn g_btnBuy g_btnDevis"
                            :link="link1.link"
                            target="_self"
                            :content="link1.cta" />
                        <Paragraph v-if="link2" :content="data.or" size="L" />
                        <Cta
                            v-if="link2"
                            type="text"
                            class="g_btn g_btnBuy g_btnDevis"
                            :link="link2.link"
                            target="_self"
                            :content="link2.cta" />
                        <Paragraph :content="data.or" size="L" />
                        <Cta
                            type="text"
                            class="g_link"
                            :link="'/'"
                            :content="data.home" />
                    </div>
                </div>
            </slot>
        </Popin>
    </Zone>
</template>

<script>
import Vue from 'vue'
import Resource from 'vue-resource'
import Textfield from '../../components/Forms/Textfield'
import Select from '../../components/Forms/Select'
// import Textarea from '../../components/Forms/Textarea'
import Radiobuttons from '../../components/Forms/Radiobuttons'
// import Checkboxes from '../../components/Forms/Checkboxes'
Vue.use(Resource)

export default {
    name: 'devisForm',
    components: {
        Textfield,
        Select,
        Radiobuttons
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        link1: {
            type: Object,
            required: false
        },
        link2: {
            type: Object,
            required: false
        },
        contrast: {
            type: String,
            default: 'light'
        }
    },
    data () {
        return {
            form: new FormData(),
            isNotValid: false,
            isChecking: false,
            isSending: false,
            isSended: false,
            isNotSended: false,
            popinOpened: false,
            isOpen: false
        }
    },
    watch: {
        isSended () {
            if (this.isSended === true) {
                this.popinOpened = true
                this.clearForms()
            }
        }
    },
    methods: {
        pageIs (page) {
            return this.$landing.project === page
        },
        openClose () {
            this.isOpen = !this.isOpen
        },
        checkForm (e) {
            console.log('checkForm')
            e.preventDefault()

            // Reinit warnings
            this.isNotValid = false
            this.isSended = false
            this.isNotSended = false
            // Checking is true
            this.isChecking = true
            // Variables to validate specific forms parts
            let successInt = false
            let successExt = false
            let successRooms = false

            let successCommon = this.checkLoop(this.data.form)
            if (this.pageIs('devis-int')) {
                successInt = this.checkLoop(this.data.int)
            }
            if (this.pageIs('devis-ext')) {
                successExt = this.checkLoop(this.data.ext)
            }
            if (this.pageIs('devis-rooms')) {
                successRooms = this.checkLoop(this.data.rooms)
            }

            setTimeout(() => {
                if (successCommon && (successInt || successExt || successRooms)) {
                    console.log('no Errors')
                    this.isChecking = false
                    this.isNotValid = false
                    this.submit()
                    return true
                } else {
                    console.log('has Errors')
                    this.isChecking = false
                    this.isNotValid = true
                    return false
                }
            }, 1000)
        },
        checkLoop (data) {
            let success = true
            let successIterative = true

            for (var item in data) {
                var obj = data[item]
                if (obj.required) {
                    switch (obj.type) {
                    case 'email':
                        if (this.has(obj)) {
                            this.checkEmail(obj)
                        }
                        break
                    case 'select':
                        this.has(obj)
                        if (obj.value === obj.options[obj.options.length - 1]) {
                            successIterative = this.checkLoop(obj.other)
                        } else {
                            this.clearErrors(obj.other)
                        }
                        break
                    case 'radio':
                        this.has(obj)
                        if (obj.value === obj.options[0].content) {
                            successIterative = this.checkLoop(obj.other)
                        } else {
                            this.clearErrors(obj.other)
                        }
                        break
                    default :
                        this.has(obj)
                    }
                    success = success && (obj.error === '') && successIterative
                }
            }

            return success
        },
        clearForms () {
            this.clearForm(this.data.form)
            this.clearForm(this.data.int)
            this.clearForm(this.data.ext)
            this.clearForm(this.data.rooms)
        },
        clearForm (data) {
            console.log('clearForm')
            for (var item in data) {
                var obj = data[item]
                obj.value = ''
                if (obj.type === 'checkbox') {
                    document.getElementById(obj.id).checked = false
                }
                if (obj.type === 'radio') {
                    let i = 0
                    for (var option in obj.options) {
                        document.getElementById(obj.id + i).checked = false
                        i++
                    }
                }
                if (obj.other) {
                    this.clearForm(obj.other)
                }
            }
        },
        clearErrors (data) {
            for (let field in data) {
                data[field].error = ''
            }
        },
        buildData (data) {
            for (let field in data) {
                // console.log(data[field].id, data[field].value)
                this.form.append(data[field].id, data[field].value)
                if (data[field].other) {
                    this.buildData(data[field].other)
                }
            }
        },
        submit () {
            this.isSending = true

            // Build data
            this.buildData(this.data.form)
            if (this.pageIs('devis-int')) {
                this.buildData(this.data.int)
            }
            if (this.pageIs('devis-ext')) {
                this.buildData(this.data.ext)
            }
            if (this.pageIs('devis-rooms')) {
                this.buildData(this.data.rooms)
            }

            // Send form to server
            setTimeout(() => {
                this.$http.post('/devis.php', this.form).then((response) => {
                    console.log(this.form)
                    console.log(response)
                    this.isSending = false
                    this.isSended = true
                }).catch((e) => {
                    console.log(e)
                    this.isSending = false
                    this.isNotSended = true
                })
            }, 1000)
        },
        has (item) {
            // Init error
            item.error = ''

            if (!item.value) {
                switch (item.type) {
                case 'select':
                    item.error = this.config.form.errors.select
                    break
                case 'radio':
                    item.error = this.config.form.errors.radio
                    break
                case 'checkbox':
                    item.error = this.config.form.errors.checkbox
                    break
                default :
                    item.error = this.config.form.errors.textfield
                }
            }
            return !!item.value
        },
        checkEmail (item) {
            // Email check regular expression
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

            // Init error
            item.format = ''

            if (!re.test(item.value)) {
                item.format = this.config.form.errors.email
                item.oldvalue = item.value
                return false
            } else return true
        }
    }
}
</script>
